import api from '@/api'
import toolBatchActions from '@/storage/toolBatchActions'
import notifier from '@/notifier'

export default {
  namespaced: true,
  state: {
    actions: [],
    totalTasks: 0,
    tasks: [],
    statuses: [],
    modules: [],
    taskItems: [],
    totalTaskItems: 0,
    fetching: false
  },
  actions: {
    async fetchModules ({ state, commit, getters }) {
      commit('fetching')

      const modulesInstalled = this.getters['module/definitionModulesInstalled']

      const modulesTmp = []
      modulesInstalled.map(moduleInstalled => toolBatchActions.map(toolBatchAction => toolBatchAction.modules.filter(module => {
        if (moduleInstalled.type === module.type && moduleInstalled.identifier === module.identifier) {
          modulesTmp.push(module)
        }
      })))

      const modules = modulesTmp.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true)
      }, Object.create(null))

      commit('setFetchDataModules', modules)
    },
    async fetchActions ({ state, commit, getters }, module) {
      commit('fetching')

      let actions = toolBatchActions

      if (module !== undefined) {
        actions = toolBatchActions.filter(
          action => !!action.modules.find(
            actionModule => (module.type === actionModule.type && module.identifier === actionModule.identifier)
          )
        )
      }

      commit('setFetchDataActions', actions)
    },
    async fetchStatuses ({ state, commit }) {
      commit('fetching')

      let statuses = []

      try {
        statuses = await api.getTaskStatuses()
      } catch (err) {}

      commit('setFetchDataStatuses', statuses)
    },
    async fetchTasks ({ state, commit }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getTasks(options)

        commit('setFetchDataTasks', { total, items })
      } catch (err) {
        commit('setFetchDataTasks', { total: 0, items: [] })
      }
    },
    async addTask ({ state, commit }, id) {
      commit('fetching')

      try {
        const task = await api.getTask(id)

        commit('addDataTask', task)
      } catch (err) {
      }
    },
    async fetchTaskItem ({ state, commit }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getLogs(options)

        if (total !== null) {
          commit('setFetchDataTaskItem', {
            total, items
          })
        }
      } catch (error) {
        state.totalTaskItems = 0
        state.taskItems = []

        if (error.response.status !== 404) {
          notifier.error('Falha ao buscar os itens da tarefa.', 'Erro')
        }
      }
    },
    async fetchTaskItemMore ({ state, commit, getters }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.getLogs(options)

        for (let i in items) {
          state.taskItems.push(items[i])
        }

        state.totalTaskItems = total
      } catch (error) {
        options.finished = true

        if (error.response.status !== 404) {
          notifier.error('Falha ao buscar os itens da tarefa.', 'Erro')
        }
      }
    },
    async cancelTask ({ state, commit, getters }, task) {
      try {
        await api.cancelTask(task._id.$oid)

        const taskTmp = state.tasks.find(item => item._id.$oid === task._id.$oid)
        taskTmp.status = (await api.getTask(task._id.$oid)).status

        notifier.success('Tarefa cancelada com sucesso.', 'Sucesso')
      } catch (err) {
        let message = 'Falha ao cancelar a tarefa.'

        if (err.response) {
          message = err.response.data.message
        }

        notifier.error(message, 'Erro')
      }
    },
    clearActions ({ state, commit }) {
      commit('setFetchDataActions', [])
    }
  },
  getters: {
    getActions: state => () => toolBatchActions,
    getTask: state => id => state.tasks.find(task => task._id.$oid === id)
  },
  mutations: {
    setFetchDataModules (state, modules) {
      state.modules = modules
      state.fetching = false
    },
    setFetchDataActions (state, actions) {
      state.actions = actions
      state.fetching = false
    },
    setFetchDataStatuses (state, statuses) {
      state.statuses = statuses
      state.fetching = false
    },
    setFetchDataTasks (state, { total, items }) {
      state.tasks = items
      state.totalTasks = total
      state.fetching = false
    },
    addDataTask (state, task) {
      state.tasks.push(task)
      state.totalTasks = state.tasks.length
      state.fetching = false
    },
    setFetchDataTaskItem (state, { total, items }) {
      state.totalTaskItems = total
      state.taskItems = items
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/toolBatchTask.js